define('gameday-index-loginifame/GDIndexLoginIframeComponent',['require','exports','module','jquery','gameday-index-component-base/GDIndexComponentBase','message-service/message-service','gameday-index-enums/enums/events/LoadEvents','app-console/app-console','gameday-index-gdaAuth/gameday-index-gdaAuth'],function(require, exports, module) {
	// require imports
	var $ = require("jquery"),
		BaseClass = require("gameday-index-component-base/GDIndexComponentBase"),
		dispatcher = require("message-service/message-service"),
		LoadEvts = require("gameday-index-enums/enums/events/LoadEvents"),
		logg = require("app-console/app-console"),
		LoginIframe = require('gameday-index-gdaAuth/gameday-index-gdaAuth');

	// instance variables
	var Superclass,
		appConfig = {};

	function GDLoginIframe(compID, divID) {
	
		this.componentID = compID;
		this.targetDiv = divID;		
		this.init();
		
	}


	BaseClass.spawn(GDLoginIframe).define({
		init: function() {
			logg.log(this.targetDiv);
            var that = this;
            
            $("#GDAudio").one("mouseover", function() {
              	 var LoginIframeInstance = new LoginIframe(that.targetDiv);
			     LoginIframeInstance.init(appConfig);            
            });


			this.buildAppSettings();
			this.initialized = true;

			dispatcher.publish(LoadEvts.componentReady, this.componentID);
		},

		buildAppSettings: function() {
			// expand / extend the appConfig obj from above
			// iterate through config objects to construct the prpper params
		}
	});

	Superclass = GDLoginIframe.superclass;
	return GDLoginIframe;
});

